import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { GetProductsParams, GetProductsResponse } from "api/api/productsApi/types";
import { List } from "api/slice/types";

export const getProducts = createAsyncThunk<
  any,
  GetProductsParams
>("products/getProducts",
  async (params: GetProductsParams, { rejectWithValue }) => {
    try {
      const data = await productsApi.getProducts(params);
      return data;
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        console.error("Error while getting products", error?.response?.data);
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting products", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  });